/**
 * The Event History "Account" filter is a free-text field that mirrors the Payments-tab UX
 * (users may type an account or a wildcard such as "INDI%"). SES matches it server-side with
 * the DSL `like` (contains) operator on `subscription.accountId`, so the value is sent as a
 * bare term — any `%` the user types is stripped, since `like` does its own containment match.
 *
 * Returns the sanitised term, or null when there is nothing meaningful to filter by
 * (empty input, or only wildcard characters).
 */
export const sanitizeAccountLikeTerm = (value: string): string | null => {
    const term = (value || '').replace(/%/g, '').trim();

    return term.length > 0 ? term : null;
};
